import React, { useState } from 'react'
import { Animated, Platform, View } from 'react-native'

/** Fade and release row space without moving the focused input in the tree. */
export function ChatComposerAccessory({ progress, children, gap = 6, hidden, duration }: {
  progress: Animated.Value
  children: React.ReactNode
  gap?: number
  hidden: boolean
  duration: number
}) {
  const [width, setWidth] = useState<number | null>(null)
  const web = Platform.OS === 'web'
  const Container = web ? View : Animated.View
  return (
    <Container
      pointerEvents={hidden ? 'none' : 'auto'}
      accessibilityElementsHidden={hidden}
      aria-hidden={hidden}
      importantForAccessibility={hidden ? 'no-hide-descendants' : 'auto'}
      style={{
        overflow: 'hidden',
        zIndex: 1,
        // Keep horizontal collapse clipping, but leave room for corner badges
        // above/below the control without changing the chat row's height.
        paddingVertical: 8,
        marginVertical: -8,
        opacity: web ? (hidden ? 0 : 1) : progress.interpolate({ inputRange: [0, 1], outputRange: [1, 0] }),
        width: width == null ? undefined : web ? (hidden ? 0 : width + gap) : progress.interpolate({ inputRange: [0, 1], outputRange: [width + gap, 0] }),
        ...(width == null ? { marginRight: gap } : null),
        ...(web ? { transitionProperty: 'width, opacity', transitionDuration: `${duration}ms`, transitionTimingFunction: 'ease-in-out' } : null),
      }}
    >
      <View
        onLayout={(event) => {
          const next = event.nativeEvent.layout.width
          if (next > 0) setWidth(current => current === null || Math.abs(current - next) > 0.5 ? next : current)
        }}
        style={{ flexDirection: 'row', alignItems: 'center', alignSelf: 'flex-start', flexShrink: 0 }}
      >
        {children}
      </View>
    </Container>
  )
}
